'use client';

import { useState } from 'react';
import Input from 'components/shared/Input/Input';
import { MagnifyingGlass } from '@1debit/icons';
import { MapLocatorAddressFormProps } from './types';

export const MapLocatorAddressForm = ({ onSearch, inputPlaceholder }: MapLocatorAddressFormProps) => {
  const [address, setAddress] = useState('');

  return (
    <form
      onSubmit={e => {
        e.preventDefault();
        if (address.length >= 4 && window.google) {
          onSearch(address);
        }
      }}>
      <Input
        value={address}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setAddress(e.target.value);
        }}
        label={inputPlaceholder}
        className="text-base text-inherit font-sans font-medium placeholder:text-inherit !border-b !border-t-0 !border-l-0 !border-r-0 !rounded-none !px-0 !bg-transparent !border-[var(--keyline-color)]"
      />
      <button
        type="submit"
        className="absolute right-3 top-1/2 -translate-y-1/2 text-inherit cursor-pointer"
        aria-label="Search location">
        <MagnifyingGlass size={20} />
      </button>
    </form>
  );
};
